module.exports = __webpack_public_path__ + "static/img/ad1.86b5f13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ad1.png
// module id = pQqT
// module chunks = 30